import {
  SharedFileRequestConfiguration,
  SharedFileRequestConfigurationsApiCreateSharedFileRequestConfigurationRequest
} from "@wingspanhq/wingspan-api-sdk";
import * as Yup from "yup";

import { CreateRequirementDefinitionSharedFileMimeType } from "../../../../../Requirements/modules/SharedFile/types";
import { mapMimeTypesToRequestFormat } from "../../../../modules/BackgroundChecks/createRequirementDefinition/mapMimeTypesToRequestFormat";
import { RequirementDefinitionSmartSharedFileFormValues } from "../../../../types";
import { RequirementDefinitionTemplateForm } from "../../types";

import { STANDARD_SHARED_FILE_FORM } from "./StandardSharedFile";

export const getSmartSharedFileForm = (
  mimeTypes: Partial<
    Record<CreateRequirementDefinitionSharedFileMimeType, boolean>
  >
): RequirementDefinitionTemplateForm<
  SharedFileRequestConfiguration,
  RequirementDefinitionSmartSharedFileFormValues,
  SharedFileRequestConfigurationsApiCreateSharedFileRequestConfigurationRequest
> => {
  return {
    ...STANDARD_SHARED_FILE_FORM,
    mapFormDataToDataSourceCreateRequest(values, template) {
      return {
        sharedFileRequestConfigurationCreate: {
          acceptedMimeTypes: mapMimeTypesToRequestFormat(mimeTypes),
          contextType: Array.isArray(template.contextType)
            ? template.contextType[0]
            : template.contextType,
          instructions: template.instructions!,
          title: template.name
        }
      };
    },
    mapFormDataToRequirementCreateRequest: undefined,
    partialForm: null,
    successCreationMessage: "Requirement created successfully",
    validationSchema: Yup.object().shape({
      instructions: Yup.string()
    })
  };
};
